export enum MeetingBotVMState {
  Pending = 1,
  Running,
  Stopped,
  Destroyed,
  HoldForInvestigation
}